<script setup lang="ts">
import MyPlanner from "@/views/playground/player/partner/planner/MyPlanner.vue";
</script>
<template>
  <my-planner></my-planner>
</template>
<style scoped></style>
